import { RoutePaths } from '../../../../config/route-paths';

export const buildKaercherLogoutUrl = (): string | null => {
  const logoutBaseUrl = process.env.REACT_APP_MY_KARCHER_AUTH_URL_LOGOUT;

  if (!logoutBaseUrl) {
    return null;
  }

  const params = new URLSearchParams();
  params.set('post_logout_redirect_uri', `${window.location.origin}${RoutePaths.LOGIN}`);

  return `${logoutBaseUrl}?${params.toString()}`;
};
